/**
 * Signed P&L percent for display: "+1.25%", "-0.40%", "0.00%". A move under
 * 0.01% keeps two significant figures ("+0.0012%") so a real gain or loss never
 * renders as "+0.00%"; only an exit exactly at entry reads "0.00%".
 */
export const formatPnlPct = (pnl: number): string => {
  const abs = Math.abs(pnl)
  const decimals = abs === 0 || abs >= 0.01 ? 2 : Math.min(8, 1 - Math.floor(Math.log10(abs)))
  const sign = pnl > 0 ? '+' : pnl < 0 ? '-' : ''
  return `${sign}${abs.toFixed(decimals)}%`
}

/** Tailwind text colour for a P&L value: green gain, red loss, grey flat. */
export const pnlColorClass = (pnl: number): string =>
  pnl > 0 ? 'text-success-600' : pnl < 0 ? 'text-danger-600' : 'text-gray-500'
